
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecoflow-balkonkraftwerk",
      function () {
        return require("private-next-pages/ecoflow-balkonkraftwerk/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecoflow-balkonkraftwerk"])
      });
    }
  